export function getBreadcrumbHeight(el) {
  const padding = (parseInt(window.getComputedStyle(el).paddingTop,10) + parseInt(window.getComputedStyle(el).paddingBottom,10));
  const height = parseInt(window.getComputedStyle(el).height,10);
  return height - padding;
}

export function clamp(breadcrumbEl) {
  var items = breadcrumbEl.getElementsByTagName('li');
  var firstChild = items[0].firstChild;
  var lineHeight = parseInt(window.getComputedStyle(firstChild).lineHeight, 10);
  while (getBreadcrumbHeight(breadcrumbEl) > lineHeight) {
    for (let i = 1; i < items.length; i++) {
      const item = items[i];
      const itemLinkText = item.getElementsByTagName('a')[0];
      if (itemLinkText.innerHTML !== '...') {
        itemLinkText.innerHTML = '...';
        break;
      }
    }
  }
}

export const breadcrumbMobileClamp = {
  name: 'breadcrumbMobileClamp',
  inserted: (el) => {
    clamp(el);
  },
  updated: (el) => {
    clamp(el);
  }
};
